import { render } from "./SafetyInformationCreate.vue?vue&type=template&id=4424b64f"
import script from "./SafetyInformationCreate.vue?vue&type=script&lang=js"
export * from "./SafetyInformationCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__